import { DataLayerApi } from "@/services/Api";

let searchProducts: string[] = [];
let categoryProducts: string[] = [];

document.addEventListener("click", function (e: Event) {
  const target = e.target as HTMLElement;
  let link: HTMLElement | null = null;
  if (target && target.tagName === "A" && target.classList.contains("product-tile__link")) {
    link = target;
  } else if (target.closest(".product-tile__link")) {
    link = target.closest(".product-tile__link");
  }

  if (link == null) {
    return;
  }

  const partno = link.dataset.partno;

  if (target.closest(".product__recomendations")) {
    if (partno) {
      DataLayerApi.createSelectItemEvent(partno, "recommendations");
    }
  } else if (target.closest(".category")) {
    if (partno) {
      DataLayerApi.createSelectItemEvent(partno, "category-page");
    }
  } else if (target.closest(".search-page")) {
    if (partno) {
      DataLayerApi.createSelectItemEvent(partno, "search-page");
    }
  } else if (target.closest(".product__relations")) {
    if (partno) {
      DataLayerApi.createSelectItemEvent(partno, "accessories");
    }
  } else if (target.closest(".product-scroll")) {
    if (partno) {
      DataLayerApi.createSelectItemEvent(partno, "product-scroll");
    }
  }
});

document.addEventListener("click", function (e: Event) {
  const target = e.target as HTMLElement;
  let link: HTMLElement | null = null;
  if (
    (target && target.classList.contains("product-tile__buy-button")) ||
    target.classList.contains("product-tile__buy-button__icon")
  ) {
    link = target;
  } else if (target.closest(".product-tile__buy-button")) {
    link = target.closest(".product-tile__buy-button");
  }

  if (link == null) {
    return;
  }
  e.preventDefault();

  const partno = link.dataset.sku;
  if (target.closest(".special-accessories")) {
    if (partno) {
      DataLayerApi.createAddToCartEvent(partno, 1, "special-accessories");
    }
  } else if (target.closest(".product__recomendations")) {
    if (partno) {
      DataLayerApi.createAddToCartEvent(partno, 1, "recommendations");
    }
  } else if (target.closest(".category")) {
    if (partno) {
      DataLayerApi.createAddToCartEvent(partno, 1, "category-page");
    }
  } else if (target.closest(".search-page")) {
    if (partno) {
      DataLayerApi.createAddToCartEvent(partno, 1, "search-page");
    }
  } else if (target.closest(".product_relations")) {
    if (partno) {
      DataLayerApi.createAddToCartEvent(partno, 1, "accessories");
    }
  } else if (target.closest(".product-scroll")) {
    if (partno) {
      DataLayerApi.createAddToCartEvent(partno, 1, "product-scroll");
    }
  }
});

export function getUniquePartNumbers(productRecomendations: ParentNode): string[] {
  const productTiles = productRecomendations.querySelectorAll(".product-tile__top");
  const uniquePartNos = new Set<string>();

  productTiles.forEach((productTile: Element) => {
    const dataPartNo = productTile.querySelector("a[data-partno]")?.getAttribute("data-partno");
    if (dataPartNo) {
      uniquePartNos.add(dataPartNo);
    }
  });

  return Array.from(uniquePartNos);
}

const productRecomendations = document.querySelectorAll(".product__recomendations");
if (productRecomendations) {
  productRecomendations.forEach((productList: Element) => {
    const partNumbers = getUniquePartNumbers(productList);
    DataLayerApi.createViewItemListEvent("recommendations", partNumbers);
  });
}

const productCategory = document.querySelectorAll(".category");
if (productCategory) {
  productCategory.forEach((productList: Element) => {
    const partNumbers = getUniquePartNumbers(productList);
    DataLayerApi.createViewItemListEvent("category", partNumbers);
    categoryProducts = partNumbers;
  });
}

const productSearch = document.querySelectorAll(".search-page");
if (productSearch) {
  productSearch.forEach((productList: Element) => {
    const partNumbers = getUniquePartNumbers(productList);
    if (partNumbers != searchProducts) {
      DataLayerApi.createViewItemListEvent("search-page", partNumbers);
      searchProducts = partNumbers;
    }
  });
}

const productAccessories = document.querySelectorAll(".product__relations");
if (productAccessories) {
  productAccessories.forEach((productList: Element) => {
    const partNumbers = getUniquePartNumbers(productList);
    DataLayerApi.createViewItemListEvent("accessories", partNumbers);
  });
}

const productScroll = document.querySelectorAll("product-scroll");
if (productScroll) {
  productScroll.forEach((productList: Element) => {
    const partNumbers = getUniquePartNumbers(productList);
    DataLayerApi.createViewItemListEvent("product-scroll", partNumbers);
  });
}

export function getProductListLink(target: Element): string {
  if (target) {
    if (target.closest(".product__recomendations")) {
      return "recommendations";
    } else if (target.closest(".category")) {
      return "category";
    } else if (target.closest(".search-page")) {
      return "search-page";
    } else if (target.closest(".product__relations")) {
      return "accessories";
    } else if (target.closest(".product-scroll")) {
      return "product-scroll";
    } else if (target.closest(".cart-popup")) {
      return "cart-popup";
    } else {
      return "";
    }
  }
  return "";
}
export function getSearchProducts(): string[] {
  return searchProducts;
}

export function getCategoryProducts(): string[] {
  return categoryProducts;
}
